import { render, staticRenderFns } from "./theoryTopicDetail.vue?vue&type=template&id=597c6f8a&scoped=true"
import script from "./theoryTopicDetail.vue?vue&type=script&lang=js"
export * from "./theoryTopicDetail.vue?vue&type=script&lang=js"
import style0 from "./theoryTopicDetail.vue?vue&type=style&index=0&id=597c6f8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597c6f8a",
  null
  
)

export default component.exports